<template>
<div>

                  <el-card class="box-card main_minheight" >

                            <div slot="header" class="tishi">
                                <span><i class="el-icon-bell"></i>&nbsp;消息</span>

                            </div>
                            <div style="text-align: center;">

                                <p  @click="sel='hit'">
                                    <router-link to="Message?mymessagetype=hit" class="caidan"> 被点赞  <span class="badge" v-if="hitNotReadNum>0">{{hitNotReadNum>100?'99+':hitNotReadNum}}</span></router-link>
                                </p>
                                <p  @click="sel='comment'">
                                    <router-link to="Message?mymessagetype=comment" class="caidan">被评论 <span class="badge" v-if="commentNotReadNum>0">{{commentNotReadNum>100?'99+':commentNotReadNum}}</span> </router-link>
                                </p>
                                <!-- <p  @click="sel='at'">
                                    <router-link to="Message?mymessagetype=at" class="caidan">被@ <span class="badge" v-if="atNotReadNum>0">{{atNotReadNum>100?'99+':atNotReadNum}}</span></router-link>
                                </p> -->
<!--                                <p :class="sel=='ss'?'tishisel':''" @click="sel='ss'">-->
<!--                                    <router-link to="UpUpass" class="caidan">私信</router-link>-->
<!--                                </p>-->
                            </div>
                        </el-card>
</div>


</template>

<script>
import PubSub from "pubsub-js";
import {dealResult} from "../../../api/common";
import {myMessageNotReadNum} from "../../../api";



    export default {
        data() {
            return {
                sel: 'hit',


                totalNotReadNum:0,
                hitNotReadNum:0,
                commentNotReadNum:0,
                atNotReadNum:0,

            }
        },
        methods: {

            getmyMessageNotReadNum(){
                console.log("mymessageLeft-messagenum---")
                this.lander = JSON.parse(this.$store.state.logininfo);
                let o={
                    uid:this.lander.uid,
                    token:this.lander.token,
                }
                myMessageNotReadNum( o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.totalNotReadNum=res.data.obj.totalNotRead;
                        this.hitNotReadNum=res.data.obj.hitNotRead;
                        this.commentNotReadNum=res.data.obj.commentNotRead;
                        this.atNotReadNum=res.data.obj.atNotRead;
                    } else{

                    }
                })
            }

        },

        mounted() {

            this.lander = JSON.parse(this.$store.state.logininfo);
          this. getmyMessageNotReadNum();


            PubSub.subscribe('changeMyNotReadMessageNum',(msg,index)=>{
               if(index=="1") this. getmyMessageNotReadNum();
            });
        }, watch: {
            $route: function (value) {
                if (value.query.mymessagetype != undefined ) {
                   this.sel= value.query.mymessagetype;
                }


            }
        },
        activated() {



        },
        deactivated() {

        }
    };
</script>

<style scoped>

</style>
